module.exports = __webpack_public_path__ + "static/media/发货通知@2x.439a956d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/发货通知@2x.png
// module id = 1373
// module chunks = 0